import { Box, Typography } from '@mui/material';
import { IconInfo } from 'assets/sidebar';
import { VTCLOUD_MARKETPLACE } from 'constants/api';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import { TypographyLink } from 'components/common/Typography';
import { isDefaultColorSystem } from 'utils/functions';
import { minuteToHourAndMinute } from '../functions';
export const InfoMeetingCC = ({ timeMinute = 60, maxNumberPeople = 100 }) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                padding: `12px ${theme.spacing(1.75)}`,
                backgroundColor: '#F2F2F2',
                maxHeight: '60px',
            }}
        >
            <IconInfo style={{ minWidth: '16px' }} />
            <Typography sx={{ paddingLeft: `${theme.spacing(2.5)}`, fontSize: { md: '15px' }, color: theme => isDefaultColorSystem() ? '#000' : theme.palette.text[700] }}>
                {t('info-meeting.content-1')} {minuteToHourAndMinute(timeMinute, t)} {t('info-meeting.content-2')}{' '}
                {maxNumberPeople} {t('info-meeting.content-3')}
            </Typography>
            <TypographyLink
                onClick={() => {
                    window.open(VTCLOUD_MARKETPLACE, '_blank');
                }}
                labelKey={'info-meeting.more'}
            />
        </Box>
    );
};
